import { ACTOR_TAGS } from "@/presentation/helpers/actorTags.js";

function getLineSlots(k) {
    return k.get(ACTOR_TAGS.LINE_SLOT).sort((a, b) => a.pos.x - b.pos.x)
}

function getLineActors(k) {
    return k.get(ACTOR_TAGS.LINE_ACTOR);
}

function getActionCardsInHand(k) {
    return k.get(ACTOR_TAGS.ACTION_CARD).sort((a, b) => a.handIndex - b.handIndex)
}

export {
    getLineSlots,
    getLineActors,
    getActionCardsInHand
}